// extracted by mini-css-extract-plugin
export default {"SolidSport":"solidsport_SolidSport__3BgPN"};